import {Component, Vue} from "vue-property-decorator";

import UIEditor from "@/components/ui-editor/UIEditor.vue"
import DZModelWiki from "@/views/百科管理/model/DZModelWiki";
import uploadFile from "@/utils/DZUploadFile";
import nyMessageToast from "@/utils/NYMessageToast";
import DZServiceWiki from "@/views/百科管理/service/DZServiceWiki";
import nyNetwork from "@/api/nyBaseNetwork";

@Component({
    components: {UIEditor}
})
export default class Index extends Vue {

    m_wiki = new DZModelWiki();

    s_wiki = new DZServiceWiki();

    created(){
        this.m_wiki.id = this.$route.query.id as string;
        if(this.m_wiki.id && this.m_wiki.id != "" ){
            this.action_get_wiki(this.m_wiki.id)
        }
        this.s_wiki.net_all_type()
    }

    action_get_wiki(id){
        this.net_get_wiki(id)
    }

    net_get_wiki(id){
        nyNetwork.net("百科详情",{id:id}, data => {
            this.m_wiki = data
            if (this.m_wiki.listCoverId) {
                this.m_wiki.imageUrl = nyNetwork.image(this.m_wiki.listCoverId);
            }
        })
    }

    action_editor_change(text){
        this.m_wiki.content = text
    }
    action_select_file(file) {
        this.m_wiki.imageUrl = URL.createObjectURL(file.raw);
        if (file.status == "ready") {
            uploadFile.uploadImage(file.raw,
                (res) => {

                }, (res) => {
                    nyMessageToast.success("图片上传成功")
                    this.m_wiki.listCoverId = res + "";
                    this.$forceUpdate()
                }, (res) => {
                    nyMessageToast.error("图片上传失败")
                    this.m_wiki.listCoverId = "";
                    this.$forceUpdate()
                });
        }
    }

    action_add_or_edit(){
        if (this.m_wiki.id && this.m_wiki.id != '') {
            this.s_wiki.net_edit_wiki(this.m_wiki,() => {
                this.$router.go(-1);
            });
        } else {
            this.s_wiki.net_add_wiki(this.m_wiki,() => {
                this.$router.back();
            });
        }
    }
}